import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import ConnectButton from '../web3/ConnectButton';
import NadFunBuyButton from '../web3/NadFunBuyButton';

const Navbar: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    // Unified navigation items for all pages
    const navItems = [
        { name: 'Story', href: '/#story' },
        { name: 'How to Buy', href: '/#how-to-buy' },
        { name: 'Roadmap', href: '/#roadmap' },
    ];

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-brand">
                    <img src="/images/logo.png" alt="Duck Logo" className="navbar-logo-img" />
                </Link>

                {/* Desktop Menu */}
                <div className="navbar-links">
                    {navItems.map((item) => (
                        <a key={item.name} href={item.href} className="navbar-link">
                            {item.name}
                        </a>
                    ))}
                    <Link to="/agents" className={`navbar-link ${location.pathname === '/agents' ? 'active' : ''}`}>
                        Agents
                    </Link>
                    <Link to="/memes" className={`navbar-link ${location.pathname === '/memes' ? 'active' : ''}`}>
                        Memes
                    </Link>
                </div>

                <div className="navbar-actions">
                    <div className="nadfun-btn-wrapper">
                        <NadFunBuyButton size="sm" />
                    </div>
                    <ConnectButton />

                    {/* Mobile Menu Button - Visible only on mobile */}
                    <button className="mobile-menu-btn" onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isOpen && (
                <div className="navbar-mobile">
                    {navItems.map((item) => (
                        <a
                            key={item.name}
                            href={item.href}
                            className="navbar-mobile-link"
                            onClick={() => setIsOpen(false)}
                        >
                            {item.name}
                        </a>
                    ))}
                    <Link
                        to="/agents"
                        className="navbar-mobile-link"
                        onClick={() => setIsOpen(false)}
                    >
                        Agents
                    </Link>
                    <Link
                        to="/memes"
                        className="navbar-mobile-link"
                        onClick={() => setIsOpen(false)}
                    >
                        Memes
                    </Link>
                    <div className="navbar-mobile-actions">
                        <NadFunBuyButton size="sm" />
                        <ConnectButton />
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
